import React, { Component } from 'react'
import CHangePasswordUi from '../../presentational/Includes/ChangePassword.popup'
import { changePasswordApi, logoutApi } from '../actionCreator'
import { changePasswordValidation } from '../../../utils/Validation'

class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            changePasswordData: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            },
            errorMsg: ''
        }
    }

    render() {
        return (
            <CHangePasswordUi
                changePasswordHandler={this.changePasswordHandler.bind(this)}
                changePasswordChange={this.changePasswordChange.bind(this)}
                errorMsg={this.state.errorMsg}
            />
        )
    }

    changePasswordChange(e, type) {
        let changePasswordData = Object.assign({}, this.state.changePasswordData)
        if (type === 'oldPassword') {
            changePasswordData.oldPassword = e.target.value
        } else if (type === 'newPassword') {
            changePasswordData.newPassword = e.target.value
        } else if (type === 'confirmPassword') {
            changePasswordData.confirmPassword = e.target.value
        }
        this.setState({
            changePasswordData,
            errorMsg: ''
        })
    }

    changePasswordHandler(type) {
        if (type === 'save') {
            let validation = changePasswordValidation(
                this.state.changePasswordData
            )
            if (validation.status) {
                changePasswordApi(
                    this.state.changePasswordData,
                    callBack => {
                        if (Object.keys(callBack).length > 0) {
                            Object.keys(callBack).forEach(key => {
                                this.setState({
                                    errorMsg: callBack[key][0]
                                })
                                // callBack[key][0]
                            })
                        } else {
                            this.props.changePasswordHandler('close')
                            logoutApi()
                        }
                    }, error => {

                    })
            } else {
                this.setState({
                    errorMsg: validation.msg
                })
            }
        } else {
            this.props.changePasswordHandler(type)
        }
    }
}

export default ChangePassword;